export enum EPositionStrategy {
  BOTTOM = 'bottom',
  CENTER = 'center',
}
